module.exports = {
    LOGIN: 'LOGIN',
    TEMPORARY_LOGIN : 'TEMPORARY_LOGIN',
    PLACE_BET: 'PLACE_BET',
    DO_ANSWER: 'DO_ANSWER',
    RECONNECT: 'RECONNECT',
    SEND_CHAT_MESSAGE: 'SEND_CHAT_MESSAGE',
    REGISTER: 'REGISTER',
    PASSWORD_RESET: 'PASSWORD_RESET',
    UPDATE_PASSWORD: 'UPDATE_PASSWORD',
    SAVE_EXP_USER :'SAVE_EXP_USER',
    MODERATE_USER:'MODERATE_USER',
    GET_BANNED_PLAYERS: 'GET_BANNED_PLAYERS',
    LOG_OUT : 'LOG_OUT',
    CALL_ACCEPTED: 'CALL_ACCEPTED',
    REFUSE_CALL: 'REFUSE_CALL',
    DELETE_USER: 'DELETE_USER',
    START_PLAYING: 'START_PLAYING',
    STOP_PLAYING: 'STOP_PLAYING',
    GET_NUMBER_OF_CHATTERS: 'GET_NUMBER_OF_CHATTERS',
    GET_USERS_LIMIT_NUMBER: 'GET_USERS_LIMIT_NUMBER'
}


// WEBPACK FOOTER //
// ./src/events/ClientToServer.js